declare namespace $ {

	type $mol_paragraph__sub_shm_markdown_text_list_1 = $mol_type_enforce<
		ReturnType< $shm_markdown_text_list['block_content'] >
		,
		ReturnType< $mol_paragraph['sub'] >
	>
	export class $shm_markdown_text_list extends $mol_text_list {
		Continuation( id: any): $mol_paragraph
	}
	
}

//# sourceMappingURL=list.view.tree.d.ts.map